import axios from '@/helpers/_core/axios';
import CONST from '@/helpers/_core/const';

export default class Application {
  static SERVICE_NAME = 'application';

  constructor({ app }) {
    this.axios = axios(app);
  }

  getApplicationSettingsByHostname(applicationAlias, hostname) {
    return this.axios.withToken().get(`${CONST.API_SAFEA_SETTINGS}/applications/${applicationAlias}/hostname/${hostname}`);
  }
}
